export enum WorkingLocationSelectValueEnum {
  None = "None",
  Manage = "Manage",
}
